import { render, staticRenderFns } from "./fattoria-poggio-di-sotto.vue?vue&type=template&id=0ae152ec&scoped=true"
import script from "./fattoria-poggio-di-sotto.vue?vue&type=script&lang=js"
export * from "./fattoria-poggio-di-sotto.vue?vue&type=script&lang=js"
import style0 from "./fattoria-poggio-di-sotto.vue?vue&type=style&index=0&id=0ae152ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae152ec",
  null
  
)

export default component.exports